/**
 * InningState Component
 */

import React from 'react';
import { useTheme } from 'styled-components';
import { InningStateProps } from './inningState.types';
import {
  StyledBasepathsWrapper,
  StyledCountWrapper,
  StyledInningWrapper,
  StyledOutsWrapper,
  StyledInningHalf,
  StyledOutsText,
} from './inningState.style';
import Outs from '../Outs/outs';
import Basepaths from '../Basepaths/basepaths';

const constrainCount = (num: number, upperbound: number, lowerbound: number): number =>
  Math.min(Math.max(num, lowerbound), upperbound);

const InningState = ({
  strikes = 0,
  balls = 0,
  outCount = 0,
  first = false,
  second = false,
  third = false,
  basesAltText,
  outsAltText,
  basepathsWidth = 24,
  outsWidth = 25,
  showCount = true,
  showOutsText = false,
  inningHalfText,
  className,
  filledColor,
  strokeColor,
  emptyColor,
  outsInactiveColor,
  outsActiveColor,
  countLabel,
  rounded = true,
  stroke = false,
  outPadding = 5,
}: InningStateProps) => {
  const { dark = false } = useTheme();

  const maxWidth: number = Math.max(basepathsWidth, outsWidth);

  const strikeCount: number = constrainCount(strikes, 3, 0);
  const ballCount: number = constrainCount(balls, 4, 0);

  return (
    <StyledInningWrapper width={maxWidth} className={className}>
      {inningHalfText && <StyledInningHalf dark={dark}>{inningHalfText}</StyledInningHalf>}
      <StyledBasepathsWrapper width={maxWidth}>
        <Basepaths
          first={first}
          second={second}
          third={third}
          altText={basesAltText}
          width={basepathsWidth}
          filledColor={filledColor}
          strokeColor={strokeColor}
          emptyColor={emptyColor}
          ariaLabel={basesAltText}
          rounded={rounded}
        />
      </StyledBasepathsWrapper>

      {!showOutsText && (
        <StyledOutsWrapper width={maxWidth}>
          <Outs
            outCount={outCount}
            altText={outsAltText}
            width={outsWidth}
            outsInactiveColor={outsInactiveColor}
            outsActiveColor={outsActiveColor}
            stroke={stroke}
            outPadding={outPadding}
          />
        </StyledOutsWrapper>
      )}

      {showCount ? (
        <StyledCountWrapper dark={dark} aria-label={countLabel}>
          <span aria-hidden="true">{`${ballCount} - ${strikeCount}`}</span>
          {showOutsText && <StyledOutsText>, {outCount} Out</StyledOutsText>}
        </StyledCountWrapper>
      ) : null}
    </StyledInningWrapper>
  );
};

export default InningState;
